import _taggedTemplateLiteral from '@babel/runtime/helpers/taggedTemplateLiteral';
import { forwardRef, createElement, Fragment, memo as memo$6, createContext as createContext$1, useRef as useRef$3, useEffect as useEffect$4, useState, useLayoutEffect as useLayoutEffect$1, useContext as useContext$4, useReducer as useReducer$1, useMemo as useMemo$7, Children, cloneElement as cloneElement$3, createRef as createRef$1, useCallback as useCallback$1 } from 'react';
import { styled, breakpoint, pxToRem, isBrowser, throttle, css, breakpointDown, withTheme } from '@moonpig/launchpad-utils';
import { Container, Flex, Box, Button, Grid, ScreenReaderOnly } from '@moonpig/launchpad-components';
import { LogoMoonpig, IconLock, LogoPhotobox, LogoHofmann, LogoPosterXxl, LogoGreetz, LogoAppStore, LogoGooglePlay, LogoVisa, LogoMastercard, LogoMaestro, LogoAmericanExpress, IconSocialFacebook, IconSocialTwitter, IconSocialInstagram, IconSocialPinterest, IconSocialYoutube, IconChevronRight, IconAccount, IconBasket, IconCross, IconSearch } from '@moonpig/launchpad-assets';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { system, spacing } from '@moonpig/launchpad-system';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { createGlobalStyle } from 'styled-components';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _objectSpread from '@babel/runtime/helpers/objectSpread';
import { spacingPx } from '@moonpig/launchpad-theme';
import Downshift from 'downshift';
var CustomLink = forwardRef(function (_ref, ref) {
  var to = _ref.to,
      _ref$linkAs = _ref.linkAs,
      LinkAs = _ref$linkAs === void 0 ? 'a' : _ref$linkAs,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["to", "linkAs", "children"]);

  return LinkAs === 'a' ? createElement("a", _extends({
    href: to
  }, rest, {
    ref: ref
  }), children) : createElement(LinkAs, _extends({
    to: to
  }, rest, {
    ref: ref
  }), children);
});
CustomLink.displayName = 'CustomLink';

var getThemeColor = function getThemeColor(color, colorVariant) {
  return function (_ref) {
    var theme = _ref.theme;
    var colorRoot = theme.colors.palette[color];
    return typeof colorRoot === 'string' ? colorRoot : colorRoot[colorVariant];
  };
};

var NAV_BP = 'xl';
var HEADER_HEIGHT_MOBILE = 108;
var HEADER_HEIGHT_MOBILE_PX = "".concat(HEADER_HEIGHT_MOBILE, "px");
var HEADER_HEIGHT_COLLAPSED = 68;
var HEADER_HEIGHT_COLLAPSED_PX = "".concat(HEADER_HEIGHT_COLLAPSED, "px");
var HEADER_HEIGHT_DESKTOP = 140;
var HEADER_HEIGHT_DESKTOP_PX = "".concat(HEADER_HEIGHT_DESKTOP, "px");
var MOBILE_NAV_WIDTH = 320;
var MOBILE_NAV_WIDTH_PX = "".concat(MOBILE_NAV_WIDTH, "px");
var KEYLINE_SIZE = 2;
var KEYLINE_SIZE_PX = "".concat(KEYLINE_SIZE, "px");
var ICON_SIZE_PX = '28px';
var TRANSITON_TIME_MS = '300ms';
var COLOR_DEFAULT_TEXT = getThemeColor('eclipse', 'base');
var COLOR_BRAND = getThemeColor('moonpink', 'base');
var COLOR_KEYLINE = getThemeColor('eclipse', 'l90');
var COLOR_LINK_HOVER = getThemeColor('moonpink', 'd60');
var COLOR_COOKIE_BANNER_BACKGROUND = getThemeColor('white');
var ZINDEX_STICKY_HEADER = 1000;
var ZINDEX_COOKIE_BANNER = 1001;

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    width: 192px;\n    height: 48px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    height: 100%;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledLogo = styled(LogoMoonpig).withConfig({
  displayName: "StyledLogo",
  componentId: "vjodcv-0"
})(["display:block;height:32px;width:100%;color:", ";", ""], COLOR_BRAND, breakpoint(NAV_BP)(_templateObject()));
var StyledCustomLink = styled(CustomLink).withConfig({
  displayName: "StyledCustomLink",
  componentId: "vjodcv-1"
})(["display:flex;width:128px;height:40px;align-items:center;", ""], breakpoint(NAV_BP)(_templateObject2()));

var LogoLink = function LogoLink(_ref) {
  var to = _ref.to,
      linkAs = _ref.linkAs;
  return createElement(StyledCustomLink, {
    to: to,
    linkAs: linkAs,
    "data-testid": "lp-nav-logo"
  }, createElement(StyledLogo, null));
};

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", "rem;\n  "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n    height: 96px;\n  "]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledHeaderWrapper = styled.div.withConfig({
  displayName: "StyledHeaderWrapper",
  componentId: "sc-1e388qi-0"
})(["background-color:white;border-bottom:2px solid ", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.palette.eclipse.l90;
});
var StyledHeader = styled.header.withConfig({
  displayName: "StyledHeader",
  componentId: "sc-1e388qi-1"
})(["display:flex;align-items:center;justify-content:space-between;height:48px;", ""], breakpoint(NAV_BP)(_templateObject$1()));
var StyledLockIcon = styled(IconLock).withConfig({
  displayName: "StyledLockIcon",
  componentId: "sc-1e388qi-2"
})(["position:relative;bottom:2px;margin-left:4px;"]);
var StyledInfo = styled.span.withConfig({
  displayName: "StyledInfo",
  componentId: "sc-1e388qi-3"
})(["font-weight:bold;font-size:", "rem;", ""], pxToRem(14), breakpoint(NAV_BP)(_templateObject2$1(), pxToRem(16)));
var defaultHomeLink = {
  to: '/'
};

var CheckoutHeader = function CheckoutHeader(_ref2) {
  var _ref2$homeLink = _ref2.homeLink,
      homeLink = _ref2$homeLink === void 0 ? defaultHomeLink : _ref2$homeLink;
  return createElement(StyledHeaderWrapper, null, createElement(Container, {
    limitWidth: true
  }, createElement(StyledHeader, null, createElement(LogoLink, homeLink), createElement(Flex, {
    alignItems: "center"
  }, createElement(StyledInfo, null, "Secure Checkout"), createElement(StyledLockIcon, {
    width: 28,
    height: 28
  })))));
};

var MAX_WIDTH = 512;
var StyledCookieBanner = styled.div.withConfig({
  displayName: "StyledCookieBanner",
  componentId: "sc-17q9v1u-0"
})(["position:fixed;bottom:0;right:0;width:100%;"]);
var StyledCard = styled.div.withConfig({
  displayName: "StyledCard",
  componentId: "sc-17q9v1u-1"
})(["", " display:flex;align-items:center;justify-content:space-between;z-index:", ";width:100%;background-color:", ";box-shadow:0 0 8px rgba(0,0,0,0.2);"], system({
  p: 6,
  maxWidth: {
    md: MAX_WIDTH
  },
  mr: {
    md: 7
  }
}), ZINDEX_COOKIE_BANNER, COLOR_COOKIE_BANNER_BACKGROUND); // eslint-disable-next-line @typescript-eslint/no-explicit-any

var CookieBanner = function CookieBanner(_ref) {
  var onCloseClick = _ref.onCloseClick,
      moreDetailsUrl = _ref.moreDetailsUrl,
      moreDetailsLinkAs = _ref.moreDetailsLinkAs;
  return createElement(StyledCookieBanner, null, createElement(Container, {
    limitWidth: true,
    padding: 0
  }, createElement(Flex, {
    justifyContent: "flex-end"
  }, createElement(StyledCard, null, createElement(Box, {
    pr: 6
  }, "We use cookies.\xA0", createElement(CustomLink, {
    to: moreDetailsUrl,
    linkAs: moreDetailsLinkAs
  }, "More Details")), createElement(Button, {
    "aria-label": "Accept and dismiss",
    onClick: onCloseClick
  }, "Accept")))));
};

var StyledMoonpigLogo = styled(LogoMoonpig).withConfig({
  displayName: "StyledMoonpigLogo",
  componentId: "sc-1tbhz1s-0"
})(["color:", ";"], COLOR_BRAND);
var items = [{
  link: '/',
  Component: StyledMoonpigLogo,
  width: '126px',
  height: '32px'
}, {
  link: 'https://www.photobox.co.uk',
  Component: LogoPhotobox,
  width: '126px',
  height: '32px'
}, {
  link: 'https://www.hofmann.es/',
  Component: LogoHofmann,
  width: '126px',
  height: '32px'
}, {
  link: 'https://www.posterxxl.de/',
  Component: LogoPosterXxl,
  width: '126px',
  height: '32px'
}, {
  link: 'https://www.greetz.nl/',
  Component: LogoGreetz,
  width: '57px',
  height: '68px'
}];
/**
 * @component
 */

var Brands = function Brands() {
  return createElement(Container, {
    limitWidth: true,
    as: "section"
  }, createElement(Box, {
    pt: 8,
    pb: 9
  }, createElement("h3", null, "Our brands"), createElement(Grid, {
    gap: true,
    as: "ul"
  }, items.map(function (_ref) {
    var link = _ref.link,
        Component = _ref.Component,
        width = _ref.width,
        height = _ref.height;
    return createElement(Box, {
      key: link,
      width: {
        xs: 1 / 2,
        md: 1 / 4,
        lg: 1 / 6
      },
      as: "li"
    }, createElement(Box, {
      maxWidth: "128px"
    }, createElement("a", {
      href: link,
      target: "_blank",
      rel: "noopener noreferrer"
    }, createElement(Component, {
      width: width,
      height: height
    }))));
  }))));
};

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n    border-bottom: 0;\n    border-right: 2px solid white;\n    margin-bottom: 0;\n  "]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledBackground = styled.div.withConfig({
  displayName: "StyledBackground",
  componentId: "sc-1dy23on-0"
})(["background:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.palette.moonpink.d60;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.palette.white;
});
var StyledLogo$1 = styled(LogoMoonpig).withConfig({
  displayName: "StyledLogo",
  componentId: "sc-1dy23on-1"
})(["box-sizing:content-box;width:128px;border-bottom:2px solid white;display:inline-block;fill:white;", " ", ""], system({
  py: 7,
  pr: {
    xs: 7,
    md: 8
  },
  mr: 8,
  mb: 7
}), breakpoint('md')(_templateObject$2()));
var StyledAddress = styled.address.withConfig({
  displayName: "StyledAddress",
  componentId: "sc-1dy23on-2"
})(["font-style:normal;max-width:35em;"]);
/**
 * @component
 */

var Address = function Address() {
  return createElement(StyledBackground, null, createElement(Container, {
    limitWidth: true
  }, createElement(Box, {
    display: {
      md: 'flex'
    },
    py: 8,
    alignItems: {
      md: 'center'
    }
  }, createElement(StyledLogo$1, null), createElement(StyledAddress, null, "10 Back Hill, London EC1R 5EN, UK, Earth, Solar System, Orion Spiral Arm, Milky Way Galaxy, Local Group, Virgo Super Cluster, The Universe"))));
};

var Link = styled.a.withConfig({
  displayName: "Link",
  componentId: "yq5cxi-0"
})(["", " color:", ";display:block;&:hover{color:", ";}"], spacing, COLOR_DEFAULT_TEXT, COLOR_LINK_HOVER);
var sections = [{
  title: 'My Moonpig',
  items: [{
    linkHref: 'http://www.google.com',
    title: 'Create Account'
  }, {
    linkHref: '/',
    title: 'Sign In'
  }, {
    linkHref: '/',
    title: 'Prepay'
  }, {
    linkHref: '/',
    title: 'Rewards'
  }, {
    linkHref: '/',
    title: 'Reminders'
  }]
}, {
  title: 'Need some help?',
  items: [{
    linkHref: '/',
    title: 'Contact us'
  }, {
    linkHref: '/',
    title: 'Delivery Info'
  }, {
    linkHref: '/',
    title: 'FAQs'
  }]
}, {
  title: 'About Us',
  items: [{
    linkHref: '/',
    title: 'Our Story'
  }, {
    linkHref: '/',
    title: 'Blog'
  }, {
    linkHref: '/',
    title: 'Tech Blog'
  }, {
    linkHref: '/',
    title: 'Press & Affiliates'
  }, {
    linkHref: '/',
    title: 'Work With Us'
  }, {
    linkHref: '/',
    title: 'Photobox Group'
  }]
}, {
  title: 'The Small Details',
  items: [{
    linkHref: '/',
    title: 'Cookies'
  }, {
    linkHref: '/',
    title: 'Privacy Notice'
  }, {
    linkHref: '/',
    title: 'Terms & Conditions'
  }]
}];

var LinkList = function LinkList(_ref) {
  var linkAs = _ref.linkAs;
  return createElement(Grid, {
    gap: true,
    "data-testid": "lp-nav-footernav-linklist"
  }, sections.map(function (_ref2) {
    var title = _ref2.title,
        items = _ref2.items;
    return createElement(Box, {
      key: title,
      width: {
        xs: 1,
        md: 1 / 2,
        lg: 1 / 4
      },
      mb: 8
    }, createElement("h3", null, title), createElement("ul", null, items.map(function (_ref3) {
      var title = _ref3.title,
          linkHref = _ref3.linkHref;
      return createElement("li", {
        key: title
      }, createElement(Link, {
        py: 4,
        as: linkAs,
        href: linkHref
      }, title));
    })));
  }));
};

var Apps = function Apps() {
  return createElement("div", {
    "data-testid": "lp-nav-footernav-apps"
  }, createElement("h3", null, "Our Apps"), createElement(Grid, null, createElement(Box, {
    mr: 4
  }, createElement("a", {
    href: "https://itunes.apple.com/app/id393730279",
    target: "_blank",
    rel: "noopener noreferrer"
  }, createElement(LogoAppStore, {
    width: "140px",
    height: "48px"
  }))), createElement(Box, null, createElement("a", {
    href: "https://play.google.com/store/apps/details?id=com.commonagency.moonpig.uk",
    target: "_blank",
    rel: "noopener noreferrer"
  }, createElement(LogoGooglePlay, {
    width: "140px",
    height: "48px"
  })))));
};

var StyledRegionLink = styled.a.withConfig({
  displayName: "StyledRegionLink",
  componentId: "sc-24240-0"
})(["", " display:flex;align-items:center;border:1px solid ", ";color:", ";transition:border 250ms ease;text-transform:uppercase;&:hover{text-decoration:none;border:1px solid ", ";}&:last-child{margin-right:0;}"], system({
  p: 4
}), function (_ref) {
  var theme = _ref.theme,
      current = _ref.current;
  return !current ? theme.colors.palette.eclipse.l80 : theme.colors.palette.moonpink.d60;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.palette.eclipse.base;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.palette.moonpink.d60;
});
var FLAG_SIZE = '27px';

var RegionSelector = function RegionSelector(_ref4) {
  var _ref4$regions = _ref4.regions,
      regions = _ref4$regions === void 0 ? [] : _ref4$regions;
  return createElement("div", {
    "data-testid": "lp-nav-footernav-region"
  }, regions.length > 0 ? createElement(Fragment, null, createElement("h3", null, "Region"), createElement(Flex, {
    as: "ul",
    flexWrap: "wrap"
  }, regions.map(function (_ref5, index) {
    var component = _ref5.component,
        linkHref = _ref5.linkHref,
        label = _ref5.label,
        shortLabel = _ref5.shortLabel,
        current = _ref5.current;
    var Flag = component;
    return createElement(Box, {
      as: "li",
      mr: 6,
      mb: 6,
      key: index
    }, createElement(StyledRegionLink, {
      href: linkHref,
      "aria-label": "Change region to ".concat(label),
      current: current
    }, createElement(Flag, {
      width: FLAG_SIZE,
      height: FLAG_SIZE
    }), createElement(Box, {
      ml: 4
    }, shortLabel)));
  }))) : null);
};

var PaymentMethods = function PaymentMethods() {
  return createElement("div", {
    "data-testid": "lp-nav-footernav-paymentmethods"
  }, createElement("h3", null, "Payment Methods"), createElement(Grid, null, createElement(Box, {
    mr: 6
  }, createElement(LogoVisa, {
    width: "63px",
    height: "40px"
  })), createElement(Box, {
    mr: 6
  }, createElement(LogoMastercard, {
    width: "51px",
    height: "40px"
  })), createElement(Box, {
    mr: 6
  }, createElement(LogoMaestro, {
    width: "51px",
    height: "40px"
  })), createElement(Box, null, createElement(LogoAmericanExpress, {
    width: "40px",
    height: "40px"
  }))));
};

var items$1 = [{
  component: IconSocialFacebook,
  linkHref: 'https://www.facebook.com/Moonpig/'
}, {
  component: IconSocialTwitter,
  linkHref: 'https://twitter.com/MoonpigUK'
}, {
  component: IconSocialInstagram,
  linkHref: 'https://www.instagram.com/Moonpig/'
}, {
  component: IconSocialPinterest,
  linkHref: 'https://www.pinterest.com/moonpiguk/'
}, {
  component: IconSocialYoutube,
  linkHref: 'https://www.youtube.com/user/MoonpigCards'
}];
var StyledLink = styled.a.withConfig({
  displayName: "StyledLink",
  componentId: "sc-1u6wyt0-0"
})(["color:", ";transition:color 200ms ease;&:hover{color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.palette.eclipse.base;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.palette.moonpink.d60;
});

var Social = function Social() {
  return createElement("div", {
    "data-testid": "lp-nav-footernav-social"
  }, createElement("h3", null, "Keep In Touch"), createElement(Grid, null, items$1.map(function (_ref3) {
    var Icon = _ref3.component,
        linkHref = _ref3.linkHref;
    return createElement(Box, {
      key: linkHref,
      mr: 6
    }, createElement(StyledLink, {
      href: linkHref,
      target: "_blank",
      rel: "noopener noreferrer"
    }, createElement(Icon, {
      width: "32px",
      height: "32px"
    })));
  })));
};

var StyledBackground$1 = styled(Box).withConfig({
  displayName: "StyledBackground",
  componentId: "sc-16p9ltp-0"
})(["background:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.palette.eclipse.l95;
});

var FooterNav = function FooterNav(_ref2) {
  var _ref2$linkAs = _ref2.linkAs,
      linkAs = _ref2$linkAs === void 0 ? 'a' : _ref2$linkAs,
      _ref2$regions = _ref2.regions,
      regions = _ref2$regions === void 0 ? [] : _ref2$regions;

  var Regions = function Regions() {
    return createElement(RegionSelector, {
      regions: regions
    });
  };

  return createElement(StyledBackground$1, {
    pt: 9
  }, createElement(Container, {
    limitWidth: true
  }, createElement(Box, {
    mb: 7
  }, createElement(LinkList, {
    linkAs: linkAs
  }), createElement(Grid, {
    gap: true
  }, [Apps, Regions, PaymentMethods, Social].map(function (Component, key) {
    return createElement(Box, {
      key: key,
      width: {
        xs: 1,
        md: 1 / 2,
        lg: 1 / 4
      },
      mb: 8
    }, createElement(Component, null));
  })))));
};
/**
 * @component
 */


var Footer = function Footer(_ref) {
  var regions = _ref.regions;
  return createElement("footer", null, createElement(FooterNav, {
    regions: regions
  }), createElement(Address, null), createElement(Brands, null));
};

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n    height: ", ";\n  "]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n    height: ", ";\n  "]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var useRef = useRef$3;
var StyledSkipToContentLink = styled.a.withConfig({
  displayName: "StyledSkipToContentLink",
  componentId: "sc-1mzdrpi-0"
})(["position:absolute;top:0;left:0;&:focus{z-index:", ";}"], ZINDEX_STICKY_HEADER + 1);
var StyledHeaderHeightEnforcer = styled.div.withConfig({
  displayName: "StyledHeaderHeightEnforcer",
  componentId: "sc-1mzdrpi-1"
})(["height:", ";", " ", ""], HEADER_HEIGHT_MOBILE_PX, breakpoint('md')(_templateObject$3(), HEADER_HEIGHT_COLLAPSED_PX), breakpoint(NAV_BP)(_templateObject2$2(), HEADER_HEIGHT_DESKTOP_PX));
var StyledHeaderWrapper$1 = styled.header.withConfig({
  displayName: "StyledHeaderWrapper",
  componentId: "sc-1mzdrpi-2"
})(["position:fixed;top:0;left:0;right:0;z-index:", ";&::before{position:absolute;top:0;right:0;bottom:0;left:0;box-shadow:0 0 16px rgba(0,0,0,0.3);opacity:0;content:'';transition:opacity ", ";}&.has-shadow::before{opacity:1;}"], ZINDEX_STICKY_HEADER, TRANSITON_TIME_MS);
var StyledHeaderWrapperInner = styled.div.withConfig({
  displayName: "StyledHeaderWrapperInner",
  componentId: "sc-1mzdrpi-3"
})(["border-bottom:", " solid ", ";background-color:white;"], KEYLINE_SIZE_PX, COLOR_KEYLINE);
var HeaderContent = memo$6(function (_ref) {
  var children = _ref.children;
  return createElement(Container, {
    limitWidth: true,
    padding: _defineProperty({}, NAV_BP, 6)
  }, createElement(Box, {
    position: "relative",
    py: _defineProperty({
      xs: 3
    }, NAV_BP, 6)
  }, children));
});
HeaderContent.displayName = 'HeaderContent';

var useShadow = function useShadow(headerHeight) {
  var useEffect = useEffect$4,
      useState$1 = useState;

  var _useState = useState$1(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasShadow = _useState2[0],
      setHasShadow = _useState2[1];

  useEffect(function () {
    var THROTTLE_INTERVAL_TIME_MS = 100;
    var animationFrameId = 0;
    var handleScroll = throttle(function () {
      animationFrameId = window.requestAnimationFrame(function () {
        setHasShadow(window.scrollY >= headerHeight);
      });
    }, THROTTLE_INTERVAL_TIME_MS);
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.cancelAnimationFrame(animationFrameId);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [headerHeight]);
  return hasShadow;
};

var useBrowserHeaderHeight = function useBrowserHeaderHeight(headerNode) {
  var useEffect = useEffect$4,
      useLayoutEffect = useLayoutEffect$1,
      useState$1 = useState;

  var _useState3 = useState$1(0),
      _useState4 = _slicedToArray(_useState3, 2),
      headerHeight = _useState4[0],
      setHeaderHeight = _useState4[1];

  useEffect(function () {
    var THROTTLE_INTERVAL_TIME_MS = 250;
    var animationFrameID = 0;
    var onResize = throttle(function () {
      return animationFrameID = window.requestAnimationFrame(function () {
        return setHeaderHeight(headerNode.current.getBoundingClientRect().height);
      });
    }, THROTTLE_INTERVAL_TIME_MS);
    window.addEventListener('resize', onResize);
    return function () {
      window.removeEventListener('resize', onResize);
      window.cancelAnimationFrame(animationFrameID);
    };
  }, [headerNode]);
  useLayoutEffect(function () {
    var animationFrameID = 0;
    animationFrameID = window.requestAnimationFrame(function () {
      setHeaderHeight(headerNode.current.getBoundingClientRect().height);
    });
    return function () {
      return window.cancelAnimationFrame(animationFrameID);
    };
  }, [headerNode]);
  return headerHeight;
};

var HeaderHeightContext = createContext$1(HEADER_HEIGHT_COLLAPSED);

var HeaderWrapper = function HeaderWrapper(_ref4) {
  var children = _ref4.children,
      mobileHeight = _ref4.mobileHeight,
      desktopHeight = _ref4.desktopHeight;
  var useHeaderHeight = isBrowser() ? useBrowserHeaderHeight : function () {
    return HEADER_HEIGHT_COLLAPSED;
  };
  var headerNode = useRef(null);
  var height = useHeaderHeight(headerNode);
  var hasShadow = useShadow(height);
  return createElement(Fragment, null, createElement(StyledSkipToContentLink, {
    href: "#mainContent"
  }, createElement(Box, {
    p: 3
  }, "Skip to content")), createElement(StyledHeaderWrapper$1, {
    "data-testid": "lp-nav-header-wrapper",
    ref: headerNode,
    hasShadow: hasShadow,
    className: hasShadow ? 'has-shadow' : ''
  }, createElement(StyledHeaderWrapperInner, null, createElement(HeaderHeightContext.Provider, {
    value: height
  }, createElement(HeaderContent, null, children)))), createElement("div", {
    id: "mainContent"
  }), createElement(StyledHeaderHeightEnforcer, {
    mobileHeight: mobileHeight,
    desktopHeight: desktopHeight,
    "data-testid": "lp-nav-header-height-enforcer"
  }));
};

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n    transform: translate3d(0, -50%, 0);\n    top: 50%;\n  "]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var POSITION_TOP = 0;
var POSITION_MIDDLE = 1;
var POSITION_BOTTOM = 2;
var StyledBurgerLine = styled.div.withConfig({
  displayName: "StyledBurgerLine",
  componentId: "sc-198ylwt-0"
})(["", ""], function (_ref) {
  var isOpen = _ref.isOpen,
      position = _ref.position;
  if (!isOpen) return {};
  var rotation = '45deg';
  var top = '7px';

  switch (position) {
    case POSITION_TOP:
      return css(["top:", ";transform:rotate(", ");"], top, rotation);

    case POSITION_MIDDLE:
      return css(["opacity:0;transform:rotate(", ");"], rotation);

    case POSITION_BOTTOM:
      return css(["top:-", ";transform:rotate(-", ");"], top, rotation);

    default:
      return null;
  }
});
var StyledToggle = styled.button.withConfig({
  displayName: "StyledToggle",
  componentId: "sc-198ylwt-1"
})(["position:absolute;top:4px;left:4px;height:40px;width:40px;text-indent:-999px;line-height:0;", " ", "{position:relative;width:18px;height:2px;margin:5px auto 5px;border-radius:2px;background-color:", ";transition:transform ", ",opacity ", ";user-select:none;}"], breakpoint('md')(_templateObject$4()), StyledBurgerLine, function (props) {
  return props.theme.colors.palette.eclipse.base;
}, TRANSITON_TIME_MS, TRANSITON_TIME_MS);
var StyledToggleWrapper = styled.div.withConfig({
  displayName: "StyledToggleWrapper",
  componentId: "sc-198ylwt-2"
})(["", ";font-size:0;"], breakpoint(NAV_BP)(_templateObject2$3()));

var Toggle = function Toggle(_ref2) {
  var isOpen = _ref2.isOpen,
      onClick = _ref2.onClick;
  return createElement(StyledToggleWrapper, null, createElement(StyledToggle, {
    onClick: onClick,
    "aria-haspopup": true,
    "aria-expanded": isOpen,
    "aria-controls": "mega-nav-content"
  }, "".concat(isOpen ? 'Close' : 'Open', " menu"), createElement(StyledBurgerLine, {
    position: POSITION_TOP,
    isOpen: isOpen
  }), createElement(StyledBurgerLine, {
    position: POSITION_MIDDLE,
    isOpen: isOpen
  }), createElement(StyledBurgerLine, {
    position: POSITION_BOTTOM,
    isOpen: isOpen
  })));
};

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  body {\n    position: fixed;\n    top: -", "px;\n    overflow: hidden;\n    width: ", "px; \n  }\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var useEffect = useEffect$4,
    useRef$1 = useRef$3;
var GlobalStyle = createGlobalStyle(_templateObject$5(), function (_ref) {
  var scrollPosition = _ref.scrollPosition;
  return scrollPosition;
}, function (_ref2) {
  var clientWidth = _ref2.clientWidth;
  return clientWidth;
});

var LockScroll = function LockScroll() {
  var ref = useRef$1({
    scrollPosition: window.pageYOffset
  });
  useEffect(function () {
    var scrollPosition = ref.current.scrollPosition;
    return function () {
      window.requestAnimationFrame(function () {
        window.scrollTo(0, scrollPosition);
      });
    };
  }, []);
  return createElement(GlobalStyle, {
    clientWidth: document.body.clientWidth,
    scrollPosition: ref.current.scrollPosition
  });
};

var createContext = createContext$1,
    useReducer = useReducer$1,
    useContext = useContext$4,
    useMemo = useMemo$7;
var OPEN_DROPDOWN = 'OPEN_DROPDOWN';
var CLOSE_DROPDOWN = 'CLOSE_DROPDOWN';
var TOGGLE_MEGANAV = 'TOGGLE_MEGANAV';
var SET_IS_DESKTOP = 'SET_IS_DESKTOP';
var OPEN_SUB_DROPDOWN = 'OPEN_SUB_DROPDOWN';
var CLOSE_SUB_DROPDOWN = 'CLOSE_SUB_DROPDOWN';
var initialState = {
  isOpen: false,
  openDropdownIndex: -1,
  openedNode: null,
  isOpenedByKeyboardOrClick: false,
  isDesktopNav: false,
  openSubDropdownIds: []
};

var reducer = function reducer(state, action) {
  var _action = _slicedToArray(action, 2),
      type = _action[0],
      payload = _action[1];

  switch (type) {
    case SET_IS_DESKTOP:
      return _objectSpread({}, state, {
        isDesktopNav: payload
      });

    case TOGGLE_MEGANAV:
      return _objectSpread({}, state, {
        isOpen: !state.isOpen
      });

    case OPEN_DROPDOWN:
      var p = payload;
      return state.openDropdownIndex === p.index ? state : _objectSpread({}, state, {
        openDropdownIndex: p.index,
        openedNode: p.target,
        isOpenedByKeyboardOrClick: p.isOpenedByKeyboardOrClick
      });

    case CLOSE_DROPDOWN:
      return _objectSpread({}, state, {
        openDropdownIndex: -1,
        isOpenedByKeyboardOrClick: false
      });

    case OPEN_SUB_DROPDOWN:
      return _objectSpread({}, state, {
        openSubDropdownIds: [].concat(_toConsumableArray(state.openSubDropdownIds), [payload])
      });

    case CLOSE_SUB_DROPDOWN:
      return _objectSpread({}, state, {
        openSubDropdownIds: state.openSubDropdownIds.filter(function (id) {
          return id !== payload;
        })
      });

    default:
      return state;
  }
};

var MegaNavContext = createContext(null);

var MegaNavProvider = function MegaNavProvider(_ref) {
  var state = _ref.state,
      children = _ref.children;

  var _useReducer = useReducer(reducer, _objectSpread({}, initialState, state)),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      newState = _useReducer2[0],
      dispatch = _useReducer2[1];

  var value = useMemo(function () {
    return [newState, dispatch];
  }, [newState]);
  return createElement(MegaNavContext.Provider, {
    value: value
  }, children);
};

var useMegaNavContext = function useMegaNavContext() {
  return useContext(MegaNavContext);
};

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: ", "px;\n    background-color: rgba(0, 0, 0, 0.25);\n    opacity: 0;\n    transition: opacity ", ", right 0ms ", ";\n\n    &.is-open {\n      opacity: 1;\n      right: 0;\n      transition: opacity ", ", right 0ms 0ms;\n    }\n  "]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n    overflow-y: auto;\n    overflow-x: hidden;\n    flex-direction: column;\n    justify-content: flex-start;\n    width: ", ";\n    transition: transform ", " cubic-bezier(.33,.35,.14,.99);\n    transform: translateX(-100%);\n\n    &.is-open {\n        transform: translateX(0);\n    }\n  "]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var useMegaNavContext$1 = useMegaNavContext,
    OPEN_DROPDOWN$1 = OPEN_DROPDOWN,
    CLOSE_DROPDOWN$1 = CLOSE_DROPDOWN;
var useContext$1 = useContext$4,
    memo = memo$6,
    useEffect$1 = useEffect$4,
    cloneElement = cloneElement$3,
    useMemo$1 = useMemo$7,
    useRef$2 = useRef$3;
var OFFSCREEN_POSITION = 9999;
var DROPDOWN_OPEN_DELAY = 150;
var DROPDOWN_CLOSE_DELAY = 300;
var StyledContent = styled.ul.withConfig({
  displayName: "StyledContent",
  componentId: "sc-19y71yw-0"
})(["display:flex;justify-content:center;height:100%;background-color:", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.palette.white;
}, breakpointDown(NAV_BP)(_templateObject$6(), MOBILE_NAV_WIDTH_PX, TRANSITON_TIME_MS)); // eslint-disable-next-line @typescript-eslint/no-explicit-any

var StyledDropdownCover = styled('div').attrs(function (_ref2) {
  var topPosition = _ref2.topPosition;
  return {
    style: {
      top: "".concat(topPosition, "px")
    }
  };
}).withConfig({
  displayName: "StyledDropdownCover",
  componentId: "sc-19y71yw-1"
})(["", ""], breakpoint(NAV_BP)(_templateObject2$4(), OFFSCREEN_POSITION, TRANSITON_TIME_MS, TRANSITON_TIME_MS, TRANSITON_TIME_MS)); // IE11 returns 'Esc' everything else returns 'Escape'

var isEscapeKey = function isEscapeKey(key) {
  return key === 'Esc' || key === 'Escape';
};

var WrappedContent = memo(function (_ref3) {
  var isOpen = _ref3.isOpen,
      children = _ref3.children,
      isDesktopNav = _ref3.isDesktopNav,
      openDropdownIndex = _ref3.openDropdownIndex,
      openedNode = _ref3.openedNode,
      dispatch = _ref3.dispatch;
  var headerHeight = useContext$1(HeaderHeightContext);
  var openTimeout;
  var closeTimeout;
  var pendingDropdownOpen = useRef$2(false);
  var areAnyDropdownsOpen = openDropdownIndex !== -1;
  useEffect$1(function () {
    return function () {
      clearTimeout(openTimeout);
      clearTimeout(closeTimeout);
    };
  }, [openTimeout, closeTimeout]);

  var handleMouseEnter = function handleMouseEnter(index, e) {
    clearTimeout(closeTimeout);
    if (pendingDropdownOpen.current || !isDesktopNav) return;
    pendingDropdownOpen.current = true;
    var target = e.target;

    var openDropdown = function openDropdown() {
      pendingDropdownOpen.current = false;
      dispatch([OPEN_DROPDOWN$1, {
        index: index,
        target: target
      }]);
    };

    if (areAnyDropdownsOpen) {
      return openDropdown();
    }

    openTimeout = setTimeout(function () {
      openDropdown();
    }, DROPDOWN_OPEN_DELAY);
  };

  var handleMouseLeave = function handleMouseLeave() {
    if (!isDesktopNav) return;
    pendingDropdownOpen.current = false;
    clearTimeout(openTimeout);
    if (!areAnyDropdownsOpen) return;
    closeTimeout = setTimeout(function () {
      dispatch([CLOSE_DROPDOWN$1]);
    }, DROPDOWN_CLOSE_DELAY);
  };

  useEffect$1(function () {
    var onKeyUp = function onKeyUp(_ref4) {
      var key = _ref4.key;

      if (isEscapeKey(key) && areAnyDropdownsOpen) {
        openedNode.focus();
        dispatch([CLOSE_DROPDOWN$1]);
      }
    };

    window.addEventListener('keyup', onKeyUp);
    return function () {
      return window.removeEventListener('keyup', onKeyUp);
    };
  }, [areAnyDropdownsOpen, dispatch, openedNode]);
  return createElement(Fragment, null, createElement(StyledDropdownCover, {
    topPosition: headerHeight,
    className: openDropdownIndex !== -1 ? 'is-open' : ''
  }), createElement(StyledContent, {
    "data-testid": "lp-nav-meganav-content",
    className: isOpen ? 'is-open' : ''
  }, Children.map(children, function (child, index) {
    return cloneElement(child, {
      onMouseEnter: function onMouseEnter(e) {
        return handleMouseEnter(index, e);
      },
      onMouseLeave: handleMouseLeave,
      index: index
    });
  })));
});

var Content = function Content(_ref5) {
  var children = _ref5.children;

  var _useMegaNavContext = useMegaNavContext$1(),
      _useMegaNavContext2 = _slicedToArray(_useMegaNavContext, 2),
      state = _useMegaNavContext2[0],
      dispatch = _useMegaNavContext2[1];

  var isDesktopNav = state.isDesktopNav,
      openDropdownIndex = state.openDropdownIndex,
      openedNode = state.openedNode,
      isOpen = state.isOpen;
  return useMemo$1(function () {
    return createElement(WrappedContent, {
      dispatch: dispatch,
      isDesktopNav: isDesktopNav,
      openDropdownIndex: openDropdownIndex,
      openedNode: openedNode,
      isOpen: isOpen
    }, children);
  }, [dispatch, isDesktopNav, openDropdownIndex, openedNode, isOpen, children]);
}; // eslint-disable-next-line @typescript-eslint/no-unused-vars


var StyledLink$1 = styled(function (_ref) {
  var isActive = _ref.isActive,
      rest = _objectWithoutProperties(_ref, ["isActive"]);

  return createElement(CustomLink, rest);
}).attrs(function (props) {
  return {
    className: props.isActive && 'is-active'
  };
}).withConfig({
  displayName: "StyledLink",
  componentId: "sc-1x2dpl9-0"
})(["display:inline-block;", " color:inherit;&.is-active,&:hover,&:focus{color:", ";text-decoration:none;span{background-image:linear-gradient( to right,", " 0%,", " 100% );background-repeat:repeat-x;background-position:0 100%;background-size:100% ", ";}}"], system({
  typography: 'bodyLabel',
  py: 3
}), COLOR_LINK_HOVER, COLOR_LINK_HOVER, COLOR_LINK_HOVER, KEYLINE_SIZE_PX);

var NavLink = function NavLink(_ref2) {
  var children = _ref2.children,
      to = _ref2.to,
      linkAs = _ref2.linkAs,
      isActive = _ref2.isActive,
      as = _ref2.as,
      rest = _objectWithoutProperties(_ref2, ["children", "to", "linkAs", "isActive", "as"]);

  return createElement(StyledLink$1, _extends({
    to: to,
    linkAs: linkAs,
    isActive: isActive
  }, rest), createElement("span", null, children));
};

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    z-index: -1;\n\n    &:focus {\n      z-index: 1;\n    }\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    cursor: pointer;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    &:hover {\n      ", " {\n        display: block;\n      }\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    border-bottom: ", " solid ", "\n    cursor: pointer;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n    &.is-active > span {\n      background-image: none;\n    }\n  "]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n    padding: ", ";\n\n    &::before {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      right: 0;\n      height: ", ";\n      content: ' ';\n    }\n  "]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var useMegaNavContext$2 = useMegaNavContext,
    OPEN_DROPDOWN$2 = OPEN_DROPDOWN;
var cloneElement$1 = cloneElement$3,
    useMemo$2 = useMemo$7,
    memo$1 = memo$6;
var StyledPrimaryLinkHitRegion = styled.span.withConfig({
  displayName: "StyledPrimaryLinkHitRegion",
  componentId: "sc-1il5k0u-0"
})(["display:none;&::before,&::after{position:absolute;z-index:1;top:0;bottom:-", ";width:1.875rem;content:' ';}&::before{left:0;transform:skewX(-45deg);}&::after{right:0;transform:skewX(45deg);}"], KEYLINE_SIZE_PX);
var StyledPrimaryLink = styled(NavLink).withConfig({
  displayName: "StyledPrimaryLink",
  componentId: "sc-1il5k0u-1"
})(["", " position:relative;width:100%;font-weight:600;outline:none;", " ", ""], system({
  typography: 'links',
  px: 6,
  py: 5
}), breakpoint(NAV_BP)(_templateObject$7(), spacingPx(6), KEYLINE_SIZE_PX), breakpointDown(NAV_BP)(_templateObject2$5()));
var StyledPrimaryLinkContainer = styled.div.withConfig({
  displayName: "StyledPrimaryLinkContainer",
  componentId: "sc-1il5k0u-2"
})(["position:relative;", " &:hover{color:", ";}"], breakpointDown(NAV_BP)(_templateObject3(), KEYLINE_SIZE_PX, COLOR_KEYLINE), COLOR_LINK_HOVER);
var StyledPrimaryItem = styled.li.withConfig({
  displayName: "StyledPrimaryItem",
  componentId: "sc-1il5k0u-3"
})(["", ""], breakpoint(NAV_BP)(_templateObject4(), StyledPrimaryLinkHitRegion));
var StyledPrimaryLinkButton = styled.button.withConfig({
  displayName: "StyledPrimaryLinkButton",
  componentId: "sc-1il5k0u-4"
})(["position:absolute;top:0;bottom:0;left:0;z-index:1;display:block;width:100%;color:transparent;", " ", ""], breakpointDown(NAV_BP)(_templateObject5()), breakpoint(NAV_BP)(_templateObject6()));
var StyledChevron = styled(IconChevronRight).withConfig({
  displayName: "StyledChevron",
  componentId: "sc-1il5k0u-5"
})(["position:absolute;top:50%;right:12px;width:", ";height:", ";transform:translateY(-50%);", ""], ICON_SIZE_PX, ICON_SIZE_PX, breakpoint(NAV_BP)(_templateObject7()));
var PrimaryLinkContainer = memo$1(function (_ref) {
  var index = _ref.index,
      isDropdownOpen = _ref.isDropdownOpen,
      dispatch = _ref.dispatch,
      label = _ref.label,
      to = _ref.to,
      linkAs = _ref.linkAs;
  return createElement(StyledPrimaryLinkContainer, null, createElement(StyledPrimaryLinkButton, {
    "data-testid": "lp-nav-primary-button-".concat(index),
    onClick: function onClick(_ref2) {
      var target = _ref2.target;
      return dispatch([OPEN_DROPDOWN$2, {
        index: index,
        target: target,
        isOpenedByKeyboardOrClick: true
      }]);
    }
  }, createElement("span", null, label)), createElement(StyledPrimaryLink, {
    to: to,
    isActive: isDropdownOpen,
    linkAs: linkAs,
    tabIndex: -1,
    "aria-hidden": "true",
    "data-testid": "lp-nav-primary-link-".concat(index)
  }, createElement(StyledPrimaryLinkHitRegion, null), createElement(StyledChevron, {
    "aria-hidden": true
  }), label));
});
PrimaryLinkContainer.displayName = 'PrimaryLinkContainer';
var WrappedPrimaryItem = memo$1(function (_ref3) {
  var _ref3$item = _ref3.item,
      to = _ref3$item.to,
      label = _ref3$item.label,
      linkAs = _ref3$item.linkAs,
      onMouseEnter = _ref3.onMouseEnter,
      onMouseLeave = _ref3.onMouseLeave,
      index = _ref3.index,
      children = _ref3.children,
      dispatch = _ref3.dispatch,
      isDropdownOpen = _ref3.isDropdownOpen;
  return createElement(StyledPrimaryItem, {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    isActive: isDropdownOpen,
    "aria-expanded": isDropdownOpen,
    "data-testid": "lp-nav-primary-item-".concat(index),
    "aria-haspopup": "true"
  }, createElement(PrimaryLinkContainer, {
    index: index,
    isDropdownOpen: isDropdownOpen,
    dispatch: dispatch,
    label: label,
    to: to,
    linkAs: linkAs
  }), Children.map(children, function (child) {
    return cloneElement$1(child, {
      index: index,
      label: label,
      primaryLinkTo: to,
      primaryLinkAs: linkAs
    });
  }));
});
WrappedPrimaryItem.displayName = 'WrappedPrimaryItem';

var PrimaryItem = function PrimaryItem(_ref4) {
  var children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["children"]);

  var _useMegaNavContext = useMegaNavContext$2(),
      _useMegaNavContext2 = _slicedToArray(_useMegaNavContext, 2),
      state = _useMegaNavContext2[0],
      dispatch = _useMegaNavContext2[1];

  var openDropdownIndex = state.openDropdownIndex;
  var isDropdownOpen = openDropdownIndex === props.index;
  return useMemo$2(function () {
    return createElement(WrappedPrimaryItem, _objectSpread({}, props, {
      dispatch: dispatch,
      openDropdownIndex: openDropdownIndex,
      isDropdownOpen: isDropdownOpen
    }), children);
  }, [props, dispatch, openDropdownIndex, isDropdownOpen, children]);
};

function _templateObject5$1() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n    padding: ", " ", "\n    box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.3);\n  "]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var useMegaNavContext$3 = useMegaNavContext,
    CLOSE_DROPDOWN$2 = CLOSE_DROPDOWN;
var createRef = createRef$1,
    useEffect$2 = useEffect$4,
    memo$2 = memo$6,
    useMemo$3 = useMemo$7;
var StyledDropdownContent = styled.div.withConfig({
  displayName: "StyledDropdownContent",
  componentId: "sc-1fv5vy4-0"
})(["background-color:white;", ""], breakpoint(NAV_BP)(_templateObject$8(), spacingPx(8), spacingPx(6)));
var StyledMobileCloseButton = styled.button.withConfig({
  displayName: "StyledMobileCloseButton",
  componentId: "sc-1fv5vy4-1"
})(["position:relative;padding-top:12px;padding-bottom:12px;padding-left:16px;padding-right:16px;width:", "px;border:0;border-bottom:", " solid ", ";color:", ";background-color:transparent;", " font-weight:600;cursor:pointer;", ""], MOBILE_NAV_WIDTH - KEYLINE_SIZE, KEYLINE_SIZE_PX, COLOR_KEYLINE, COLOR_LINK_HOVER, system({
  typography: 'links'
}), breakpoint(NAV_BP)(_templateObject2$6()));
var StyledDesktopPrimaryLinkWrapper = styled.div.withConfig({
  displayName: "StyledDesktopPrimaryLinkWrapper",
  componentId: "sc-1fv5vy4-2"
})(["", " text-align:center;", ""], system({
  pb: 7
}), breakpointDown(NAV_BP)(_templateObject3$1()));
var StyledDesktopPrimaryLink = styled(CustomLink).withConfig({
  displayName: "StyledDesktopPrimaryLink",
  componentId: "sc-1fv5vy4-3"
})(["", " display:inline-block;&:hover,&:focus{text-decoration:none;}"], system({
  py: 3
}));
var StyledMobilePrimaryLink = styled(CustomLink).withConfig({
  displayName: "StyledMobilePrimaryLink",
  componentId: "sc-1fv5vy4-4"
})(["display:block;", " font-weight:600;border-bottom:", " solid ", ";color:inherit;&:hover,&:focus{text-decoration:none;color:", ";}", ""], system({
  typography: 'links',
  px: 6,
  py: 5
}), KEYLINE_SIZE_PX, COLOR_KEYLINE, COLOR_LINK_HOVER, breakpoint(NAV_BP)(_templateObject4$1()));
var StyledChevron$1 = styled(IconChevronRight).withConfig({
  displayName: "StyledChevron",
  componentId: "sc-1fv5vy4-5"
})(["position:absolute;top:50%;left:12px;width:", ";height:", ";transform:rotate(180deg) translateY(50%);color:", ";", ""], ICON_SIZE_PX, ICON_SIZE_PX, COLOR_DEFAULT_TEXT, breakpoint(NAV_BP)(_templateObject5$1()));
var WrappedDropdownContent = memo$2(function (_ref) {
  var label = _ref.label,
      isOpen = _ref.isOpen,
      children = _ref.children,
      primaryLinkTo = _ref.primaryLinkTo,
      primaryLinkAs = _ref.primaryLinkAs,
      dropdownIndex = _ref.dropdownIndex,
      isOpenedByKeyboardOrClick = _ref.isOpenedByKeyboardOrClick,
      isDesktopNav = _ref.isDesktopNav,
      dispatch = _ref.dispatch;
  var node = createRef();
  useEffect$2(function () {
    if (isOpen && isOpenedByKeyboardOrClick) {
      node.current && node.current.focus();
    }
  }, [isOpen, node, isOpenedByKeyboardOrClick]);
  return createElement(StyledDropdownContent, null, createElement(StyledMobileCloseButton, {
    "data-testid": "lp-nav-dropdown-".concat(dropdownIndex, "-mobile-close-button"),
    tabIndex: isOpen ? 0 : -1,
    onClick: function onClick() {
      return dispatch([CLOSE_DROPDOWN$2]);
    }
  }, label, createElement(StyledChevron$1, {
    "aria-hidden": true
  })), isOpen && isOpenedByKeyboardOrClick && isDesktopNav && createElement(StyledDesktopPrimaryLinkWrapper, null, createElement(StyledDesktopPrimaryLink, {
    "data-testid": "lp-nav-dropdown-".concat(dropdownIndex, "-landing-page-desktop-link"),
    ref: node,
    to: primaryLinkTo,
    linkAs: primaryLinkAs
  }, "All ", label)), createElement(Grid, {
    justifyContent: "center"
  }, createElement(Box, {
    width: _defineProperty({
      xs: 1
    }, NAV_BP, 11 / 12)
  }, createElement(Grid, {
    justifyContent: "center",
    gap: _defineProperty({
      xs: 0
    }, NAV_BP, 7),
    as: "ul"
  }, children))), !isDesktopNav && createElement(StyledMobilePrimaryLink, {
    "data-testid": "lp-nav-dropdown-".concat(dropdownIndex, "-landing-page-mobile-link"),
    to: primaryLinkTo,
    linkAs: primaryLinkAs
  }, "All ", label));
});
WrappedDropdownContent.displayName = 'WrappedDropdownContent';

var DropdownContent = function DropdownContent(props) {
  var _useMegaNavContext = useMegaNavContext$3(),
      _useMegaNavContext2 = _slicedToArray(_useMegaNavContext, 2),
      state = _useMegaNavContext2[0],
      dispatch = _useMegaNavContext2[1];

  var isOpenedByKeyboardOrClick = state.isOpenedByKeyboardOrClick,
      isDesktopNav = state.isDesktopNav;
  return useMemo$3(function () {
    return createElement(WrappedDropdownContent, _objectSpread({}, props, {
      isOpenedByKeyboardOrClick: isOpenedByKeyboardOrClick,
      isDesktopNav: isDesktopNav,
      dispatch: dispatch
    }));
  }, [props, isDesktopNav, isOpenedByKeyboardOrClick, dispatch]);
};

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n    position: fixed;\n    top: ", "px;\n    left: -100%;\n    width: ", "px;\n    max-width: 100%;\n    padding: 0 ", ";\n    opacity: 0;\n    transform: translateX(-50%);\n    transition: all 0ms ", ", opacity ", " 0ms;\n\n    &.is-open {\n      left: 50%;\n      transition: all 0ms 0ms, opacity ", " 0ms;\n    }\n\n    &.has-open-dropdown {\n      opacity: 1;\n      transition-delay: 0ms;\n    }\n  "]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    min-height: calc(100vh - ", "px);\n    transform: translateX(", ");\n    transition: transform ", " 0s, width 0s ", ";\n    border-left: ", " solid ", ";\n    background-color: white;\n    width: 0;\n    overflow: hidden;\n\n    &.is-open {\n      z-index: 2;\n      width: ", ";\n      transform: translateX(0);\n      transition: transform ", " 0s, width 0s 0s;\n    }\n  "]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

var useContext$2 = useContext$4,
    cloneElement$2 = cloneElement$3,
    useMemo$4 = useMemo$7,
    memo$3 = memo$6;
var SITE_WIDTH_INCLUDING_PADDING = '1248';
/*
  The following properties are set to fix a rendering bug in Safari.
  - width
  - overflow
*/

var StyledDropdown = styled.div.withConfig({
  displayName: "StyledDropdown",
  componentId: "sc-72n0gj-0"
})(["z-index:1;", " ", ""], breakpointDown(NAV_BP)(_templateObject$9(), function (_ref) {
  var headerHeight = _ref.headerHeight;
  return headerHeight;
}, MOBILE_NAV_WIDTH_PX, TRANSITON_TIME_MS, TRANSITON_TIME_MS, KEYLINE_SIZE_PX, COLOR_KEYLINE, MOBILE_NAV_WIDTH_PX, TRANSITON_TIME_MS), breakpoint(NAV_BP)(_templateObject2$7(), function (_ref2) {
  var headerHeight = _ref2.headerHeight;
  return headerHeight;
}, SITE_WIDTH_INCLUDING_PADDING, spacingPx(7), TRANSITON_TIME_MS, TRANSITON_TIME_MS, TRANSITON_TIME_MS));
var WrappedDropdown = memo$3(function (_ref3) {
  var dropdownIndex = _ref3.index,
      children = _ref3.children,
      label = _ref3.label,
      primaryLinkTo = _ref3.primaryLinkTo,
      primaryLinkAs = _ref3.primaryLinkAs,
      isOpen = _ref3.isOpen,
      areAnyDropdownsOpen = _ref3.areAnyDropdownsOpen;
  var headerHeight = useContext$2(HeaderHeightContext);
  return createElement(StyledDropdown, {
    "aria-hidden": !isOpen,
    headerHeight: headerHeight,
    isOpen: isOpen,
    className: "".concat(isOpen ? 'is-open' : '', " ").concat(areAnyDropdownsOpen ? 'has-open-dropdown' : ''),
    "data-testid": "lp-nav-dropdown-".concat(dropdownIndex),
    areAnyDropdownsOpen: areAnyDropdownsOpen
  }, createElement(DropdownContent, {
    dropdownIndex: dropdownIndex,
    isOpen: isOpen,
    label: label,
    primaryLinkTo: primaryLinkTo,
    primaryLinkAs: primaryLinkAs
  }, Children.map(children, function (child) {
    return cloneElement$2(child, {
      isParentDropdownOpen: isOpen,
      dropdownIndex: dropdownIndex
    });
  })));
});
WrappedDropdown.displayName = 'WrappedDropdown';

var Dropdown = function Dropdown(_ref4) {
  var children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["children"]);

  var _useMegaNavContext = useMegaNavContext(),
      _useMegaNavContext2 = _slicedToArray(_useMegaNavContext, 1),
      state = _useMegaNavContext2[0];

  var openDropdownIndex = state.openDropdownIndex;
  var isOpen = openDropdownIndex === props.index;
  var areAnyDropdownsOpen = openDropdownIndex !== -1;
  return useMemo$4(function () {
    return createElement(WrappedDropdown, _objectSpread({}, props, {
      isOpen: isOpen,
      areAnyDropdownsOpen: areAnyDropdownsOpen
    }), children);
  }, [props, isOpen, areAnyDropdownsOpen, children]);
};

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    border-bottom: ", " solid ", ";\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n  "]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteral(["\n    &:last-child {\n      ", "\n    }\n  "]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    font-weight: 600;\n\n    &:hover,\n    &:focus {\n      color: ", ";\n    }\n  "]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    border-bottom: ", " solid ", ";\n    font-weight: 600;\n  "]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteral(["\n    overflow: hidden;\n    transition: height ", ";    \n  "]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n    height: auto !important;\n  "]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}

var useLayoutEffect = useLayoutEffect$1;
var useMegaNavContext$4 = useMegaNavContext,
    CLOSE_SUB_DROPDOWN$1 = CLOSE_SUB_DROPDOWN,
    OPEN_SUB_DROPDOWN$1 = OPEN_SUB_DROPDOWN;
var useMemo$5 = useMemo$7,
    memo$4 = memo$6;
var StyledSubDropdownItems = styled.div.withConfig({
  displayName: "StyledSubDropdownItems",
  componentId: "sc-1ucvivb-0"
})(["", " ", ""], breakpoint(NAV_BP)(_templateObject$a()), breakpointDown(NAV_BP)(_templateObject2$8(), TRANSITON_TIME_MS));

var useBrowserAnimateHeight = function useBrowserAnimateHeight(dropdownNode, dropdownContentNode, isOpen) {
  useLayoutEffect(function () {
    var node = dropdownNode.current;

    var applyHeight = function applyHeight(height) {
      return node.style.height = height;
    };

    var setAutoFrameId = 0;
    var setHeightFrameId = window.requestAnimationFrame(function () {
      var height = dropdownContentNode.current.getBoundingClientRect().height;
      applyHeight("".concat(height, "px"));
      if (!isOpen) return setTimeout(function () {
        return applyHeight('0px');
      }, 0);
      return undefined;
    });

    var setAuto = function setAuto() {
      setAutoFrameId = window.requestAnimationFrame(function () {
        return applyHeight('auto');
      });
    };

    if (isOpen) {
      node.addEventListener('transitionend', setAuto);
    }

    return function () {
      node.removeEventListener('transitionend', setAuto);
      window.cancelAnimationFrame(setHeightFrameId);
      window.cancelAnimationFrame(setAutoFrameId);
    };
  }, [dropdownContentNode, dropdownNode, isOpen]);
};

var noop = function noop() {};

var useAnimateHeight = isBrowser() ? useBrowserAnimateHeight : noop;

var SubDropdownItems = function SubDropdownItems(_ref) {
  var dropdownIndex = _ref.dropdownIndex,
      isOpen = _ref.isOpen,
      children = _ref.children;
  var dropdownNode = useRef$3(null);
  var dropdownContentNode = useRef$3(null);
  useAnimateHeight(dropdownNode, dropdownContentNode, isOpen);
  return createElement(StyledSubDropdownItems, {
    ref: dropdownNode,
    "data-testid": "lp-nav-sub-dropdown-".concat(dropdownIndex, "-items")
  }, createElement("ul", {
    ref: dropdownContentNode
  }, children));
};

var StyledSubDropdownTitle = styled.h3.withConfig({
  displayName: "StyledSubDropdownTitle",
  componentId: "sc-1ucvivb-1"
})(["", " position:relative;margin-bottom:0;", " ", ""], system({
  px: 6,
  py: 5
}), breakpoint(NAV_BP)(_templateObject3$2(), system({
  px: 0,
  pt: 0,
  pb: 4,
  mb: 4,
  typography: 'bodyLabel'
}), KEYLINE_SIZE_PX, COLOR_KEYLINE), breakpointDown(NAV_BP)(_templateObject4$2(), system({
  typography: 'links'
}), COLOR_LINK_HOVER));
var StyledSubDropdownToggle = styled.button.withConfig({
  displayName: "StyledSubDropdownToggle",
  componentId: "sc-1ucvivb-2"
})(["position:absolute;top:0;right:0;bottom:0;left:0;width:", ";", ""], MOBILE_NAV_WIDTH_PX, breakpoint(NAV_BP)(_templateObject5$2()));
var StyledSubDropdownItem = styled.li.withConfig({
  displayName: "StyledSubDropdownItem",
  componentId: "sc-1ucvivb-3"
})(["", ""], breakpointDown(NAV_BP)(_templateObject6$1(), system({
  pb: 6
})));
var StyledSubDropdownLink = styled(NavLink).withConfig({
  displayName: "StyledSubDropdownLink",
  componentId: "sc-1ucvivb-4"
})(["", " ", ""], system({
  py: _defineProperty({
    xs: 5
  }, NAV_BP, 3),
  pl: _defineProperty({
    xs: 9
  }, NAV_BP, 0)
}), breakpointDown(NAV_BP)(_templateObject7$1())); // eslint-disable-next-line @typescript-eslint/no-unused-vars

var StyledChevron$2 = styled(function (_ref2) {
  var isOpen = _ref2.isOpen,
      props = _objectWithoutProperties(_ref2, ["isOpen"]);

  return createElement(IconChevronRight, props);
}).attrs(function (_ref3) {
  var isOpen = _ref3.isOpen;
  return {
    style: {
      transform: "translateY(-50%) rotate(".concat(isOpen ? '-' : '', "90deg)")
    }
  };
}).withConfig({
  displayName: "StyledChevron",
  componentId: "sc-1ucvivb-5"
})(["position:absolute;top:50%;right:12px;width:", ";height:", ";", ""], ICON_SIZE_PX, ICON_SIZE_PX, breakpoint(NAV_BP)(_templateObject8()));
var StyledSubDropdown = styled.div.withConfig({
  displayName: "StyledSubDropdown",
  componentId: "sc-1ucvivb-6"
})(["", ""], breakpointDown(NAV_BP)(_templateObject9(), KEYLINE_SIZE_PX, COLOR_KEYLINE));
var WrappedSubDropdown = memo$4(function (_ref4) {
  var _ref4$subDropdown = _ref4.subDropdown,
      title = _ref4$subDropdown.title,
      items = _ref4$subDropdown.items,
      dropdownIndex = _ref4.dropdownIndex,
      isOpen = _ref4.isOpen,
      dispatch = _ref4.dispatch,
      _ref4$isParentDropdow = _ref4.isParentDropdownOpen,
      isParentDropdownOpen = _ref4$isParentDropdow === void 0 ? false : _ref4$isParentDropdow,
      id = _ref4.id;
  return createElement(Box, {
    as: "li",
    width: _defineProperty({
      xs: 1
    }, NAV_BP, 1 / 6)
  }, createElement(StyledSubDropdown, null, createElement(StyledSubDropdownTitle, {
    "data-testid": "lp-nav-sub-dropdown-".concat(dropdownIndex, "-title")
  }, createElement(StyledSubDropdownToggle, {
    "data-testid": "lp-nav-sub-dropdown-".concat(dropdownIndex, "-toggle"),
    tabIndex: isParentDropdownOpen ? 0 : -1,
    onClick: function onClick() {
      return dispatch([isOpen ? CLOSE_SUB_DROPDOWN$1 : OPEN_SUB_DROPDOWN$1, id]);
    }
  }, createElement(StyledChevron$2, {
    "data-testid": "lp-nav-sub-dropdown-".concat(dropdownIndex, "-chevron"),
    isOpen: isOpen,
    "aria-hidden": true
  })), title, createElement(ScreenReaderOnly, null, " Category")), createElement(SubDropdownItems, {
    dropdownIndex: dropdownIndex,
    isOpen: isOpen
  }, items.map(function (_ref6) {
    var to = _ref6.to,
        label = _ref6.label,
        linkAs = _ref6.linkAs;
    return createElement(StyledSubDropdownItem, {
      key: label
    }, createElement(StyledSubDropdownLink, {
      to: to,
      tabIndex: isParentDropdownOpen ? 0 : -1,
      linkAs: linkAs,
      "data-testid": "lp-nav-sub-dropdown-".concat(dropdownIndex, "-link")
    }, label));
  }))));
});
WrappedSubDropdown.displayName = 'WrappedSubDropdown';

var SubDropdown = function SubDropdown(_ref7) {
  var children = _ref7.children,
      props = _objectWithoutProperties(_ref7, ["children"]);

  var _useMegaNavContext = useMegaNavContext$4(),
      _useMegaNavContext2 = _slicedToArray(_useMegaNavContext, 2),
      openSubDropdownIds = _useMegaNavContext2[0].openSubDropdownIds,
      dispatch = _useMegaNavContext2[1];

  var isOpen = openSubDropdownIds.includes(props.id);
  return useMemo$5(function () {
    return createElement(WrappedSubDropdown, _objectSpread({}, props, {
      isOpen: isOpen,
      dispatch: dispatch
    }), children);
  }, [props, isOpen, dispatch, children]);
};

function _templateObject4$3() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n  "]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n      left: 0;\n      transition-delay: 0ms;\n    "]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    top: ", "px;\n    left: -100vw;\n    height: calc(100vh - ", "px);\n    width: 100vw;\n    transition-delay: ", ";\n  "]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}

var MegaNavProvider$1 = MegaNavProvider,
    useMegaNavContext$5 = useMegaNavContext,
    TOGGLE_MEGANAV$1 = TOGGLE_MEGANAV,
    SET_IS_DESKTOP$1 = SET_IS_DESKTOP;
var useEffect$3 = useEffect$4,
    useContext$3 = useContext$4,
    useCallback = useCallback$1,
    useMemo$6 = useMemo$7,
    memo$5 = memo$6; // eslint-disable-next-line @typescript-eslint/no-explicit-any

var StyledMegaNavClose = styled('button').attrs(function (_ref) {
  var isOpen = _ref.isOpen;
  return {
    style: {
      opacity: isOpen ? 1 : 0
    }
  };
}).withConfig({
  displayName: "StyledMegaNavClose",
  componentId: "sc-40rcg8-0"
})(["position:absolute;top:0;bottom:0;left:0;width:100%;outline:none;background-color:rgba(0,0,0,0.25);transition:opacity ", ";", ""], TRANSITON_TIME_MS, breakpoint(NAV_BP)(_templateObject$b()));
var StyledMegaNavInner = styled.div.withConfig({
  displayName: "StyledMegaNavInner",
  componentId: "sc-40rcg8-1"
})(["", " ", " &.is-open{", "}"], system({
  mb: _defineProperty({}, NAV_BP, -6)
}), breakpointDown(NAV_BP)(_templateObject2$9(), function (_ref2) {
  var headerHeight = _ref2.headerHeight;
  return headerHeight;
}, function (_ref3) {
  var headerHeight = _ref3.headerHeight;
  return headerHeight;
}, TRANSITON_TIME_MS), breakpointDown(NAV_BP)(_templateObject3$3()));
var StyledMegaNav = styled.nav.withConfig({
  displayName: "StyledMegaNav",
  componentId: "sc-40rcg8-2"
})(["", ""], breakpointDown(NAV_BP)(_templateObject4$3()));
var WrappedMegaNavComponent = memo$5(function (_ref4) {
  var items = _ref4.items,
      theme = _ref4.theme,
      isOpen = _ref4.isOpen,
      isDesktopNav = _ref4.isDesktopNav,
      dispatch = _ref4.dispatch,
      onToggle = _ref4.onToggle;
  var headerHeight = useContext$3(HeaderHeightContext);
  var handleToggle = useCallback(function () {
    onToggle && onToggle(isOpen);
    dispatch([TOGGLE_MEGANAV$1]);
  }, [dispatch, isOpen, onToggle]);
  useEffect$3(function () {
    var isDesktop = window.matchMedia("(min-width: ".concat(theme.breakpoints.map[NAV_BP], "px)")).matches;
    dispatch([SET_IS_DESKTOP$1, isDesktop]);
  }, [dispatch, headerHeight, theme.breakpoints.map]);
  useEffect$3(function () {
    if (isDesktopNav && isOpen) {
      handleToggle();
    }
  }, [handleToggle, isDesktopNav, isOpen]);
  return createElement(Fragment, null, isOpen ? createElement(LockScroll, null) : null, createElement(StyledMegaNav, {
    "aria-label": "Main Navigation"
  }, createElement(Toggle, {
    isOpen: isOpen,
    onClick: handleToggle
  }), createElement(StyledMegaNavInner, {
    id: "mega-nav-content",
    "data-testid": "lp-nav-meganav-inner",
    headerHeight: headerHeight,
    isOpen: isOpen,
    className: isOpen ? 'is-open' : ''
  }, createElement(StyledMegaNavClose, {
    "data-testid": "lp-nav-meganav-close",
    onClick: function onClick() {
      return dispatch([TOGGLE_MEGANAV$1]);
    },
    isOpen: isOpen,
    tabIndex: -1
  }), createElement(Content, null, items.map(function (item, itemIndex) {
    return createElement(PrimaryItem, {
      key: itemIndex,
      item: item
    }, createElement(Dropdown, null, item.dropdown.map(function (subDropdown, subDropdownIndex) {
      return createElement(SubDropdown, {
        key: subDropdownIndex,
        id: "".concat(itemIndex, "-").concat(subDropdownIndex),
        subDropdown: subDropdown
      });
    })));
  })))));
});
WrappedMegaNavComponent.displayName = 'WrappedMegaNavComponent';

var MegaNavComponent = function MegaNavComponent(props) {
  var _useMegaNavContext = useMegaNavContext$5(),
      _useMegaNavContext2 = _slicedToArray(_useMegaNavContext, 2),
      state = _useMegaNavContext2[0],
      dispatch = _useMegaNavContext2[1];

  var isOpen = state.isOpen,
      isDesktopNav = state.isDesktopNav;
  return useMemo$6(function () {
    return createElement(WrappedMegaNavComponent, _extends({}, props, {
      isOpen: isOpen,
      dispatch: dispatch,
      isDesktopNav: isDesktopNav
    }));
  }, [props, isOpen, dispatch, isDesktopNav]);
};

var MegaNav = function MegaNav(props) {
  var NavWithTheme = withTheme(function (props) {
    return createElement(MegaNavProvider$1, null, createElement(MegaNavComponent, props));
  });
  return createElement(NavWithTheme, props);
};

function _templateObject3$4() {
  var data = _taggedTemplateLiteral(["\n    min-width: 48px;\n    height: 48px;\n  "]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteral(["\n    top: 16px;\n    right: 0;\n  "]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteral(["\n    position: static;\n  "]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}

var StyledUtilityMenu = styled.div.withConfig({
  displayName: "StyledUtilityMenu",
  componentId: "u1fxfr-0"
})(["display:flex;top:4px;right:8px;", ""], breakpoint(NAV_BP)(_templateObject$c()));
var StyledTopSection = styled.div.withConfig({
  displayName: "StyledTopSection",
  componentId: "u1fxfr-1"
})(["display:flex;", ""], breakpoint(NAV_BP)(_templateObject2$a()));
var StyledUtilityLink = styled(Link).withConfig({
  displayName: "StyledUtilityLink",
  componentId: "u1fxfr-2"
})(["display:flex;align-items:center;justify-content:center;min-width:40px;height:40px;", ""], breakpoint(NAV_BP)(_templateObject3$4()));

var UtilityMenu = function UtilityMenu() {
  return createElement(StyledUtilityMenu, null, createElement(StyledTopSection, null, createElement(StyledUtilityLink, {
    href: "/uk/myaccount"
  }, createElement(IconAccount, {
    width: ICON_SIZE_PX,
    height: ICON_SIZE_PX
  }), createElement(ScreenReaderOnly, null, "My Account")), createElement(StyledUtilityLink, {
    href: "/uk/basket"
  }, createElement(IconBasket, {
    width: ICON_SIZE_PX,
    height: ICON_SIZE_PX
  }), createElement(ScreenReaderOnly, null, "Basket"))));
};

var Header = function Header(_ref) {
  var navItems = _ref.navItems,
      homeLink = _ref.homeLink,
      children = _ref.children,
      onMegaNavToggle = _ref.onMegaNavToggle;
  return createElement(HeaderWrapper, null, createElement(Grid, {
    justifyContent: "space-between",
    alignItems: "center"
  }, createElement(Box, {
    ml: {
      xs: 9,
      xl: 0
    }
  }, createElement(LogoLink, homeLink)), createElement(Box, {
    order: {
      xs: 0,
      md: 1
    }
  }, createElement(UtilityMenu, null)), createElement(Box, {
    width: {
      xs: 1,
      md: 1 / 2,
      lg: 3 / 5
    },
    my: 4,
    mx: {
      xs: 5,
      md: 0
    }
  }, children), createElement(Box, {
    order: {
      lg: 1
    },
    mt: {
      lg: 4
    }
  }, createElement(MegaNav, {
    onToggle: onMegaNavToggle,
    items: navItems
  }))));
};

var BUTTON_SIZE = 40;
var StyledForm = styled.form.withConfig({
  displayName: "StyledForm",
  componentId: "lab85s-0"
})(["height:", "px;position:relative;"], BUTTON_SIZE + 2);
var StyledSearchWrapper = styled.div.withConfig({
  displayName: "StyledSearchWrapper",
  componentId: "lab85s-1"
})(["background-color:white;left:0;position:absolute;right:0;z-index:3;"]);
var sharedButtonStyles = css(["", " display:flex;align-items:center;position:absolute;top:0;background-color:transparent;&:not(:disabled){cursor:pointer;}"], system({
  p: 3
}));
var StyledSearchButton = styled.button.attrs(function (_ref) {
  var disabled = _ref.disabled;
  return {
    className: disabled ? 'is-disabled' : ''
  };
}).withConfig({
  displayName: "StyledSearchButton",
  componentId: "lab85s-2"
})(["", " height:", "px;right:0;color:", ";background-color:", ";&.is-disabled{color:inherit;background-color:transparent;}"], sharedButtonStyles, BUTTON_SIZE, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.palette.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.palette.eclipse.base;
});
var StyledClearButton = styled.button.attrs(function (_ref4) {
  var hidden = _ref4.hidden;
  return {
    className: hidden ? 'is-hidden' : ''
  };
}).withConfig({
  displayName: "StyledClearButton",
  componentId: "lab85s-3"
})(["", " color:inherit;right:", "px;&.is-hidden{display:none;}"], sharedButtonStyles, BUTTON_SIZE);
var StyledInput = styled.input.attrs(function (_ref5) {
  var value = _ref5.value;
  return {
    className: value ? 'is-active' : ''
  };
}).withConfig({
  displayName: "StyledInput",
  componentId: "lab85s-4"
})(["", " display:block;margin:0;min-height:", "px;width:100%;border:1px solid transparent;&::-ms-clear{display:none;}&::placeholder{", "}&:focus{outline:0;border:1px solid ", ";}&.is-active{padding-right:", "px;background-color:", ";&:focus{border:1px solid transparent;}}"], system({
  py: 4,
  pl: 6,
  typography: 'links',
  bgcolor: 'palette.eclipse.l95',
  color: 'palette.eclipse.base'
}), BUTTON_SIZE, system({
  color: 'placeholder'
}), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.palette.eclipse.base;
}, BUTTON_SIZE * 2, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.palette.white;
});
var StyledUnderline = styled.div.attrs(function (_ref8) {
  var isActive = _ref8.isActive;
  return {
    className: isActive && 'is-active'
  };
}).withConfig({
  displayName: "StyledUnderline",
  componentId: "lab85s-5"
})(["", " transform:scaleX(0);transform-origin:0;height:2px;margin-top:-2px;transition:transform 250ms ease;&.is-active{transform:scaleX(1);}"], system({
  bgcolor: 'text'
})); // eslint-disable-next-line @typescript-eslint/no-explicit-any

var StyledSuggestion = styled('li').attrs(function (_ref9) {
  var highlighted = _ref9.highlighted,
      theme = _ref9.theme;
  return {
    style: {
      backgroundColor: highlighted ? theme.colors.palette.eclipse.l95 : null
    }
  };
}).withConfig({
  displayName: "StyledSuggestion",
  componentId: "lab85s-6"
})(["", " cursor:pointer;&:hover{background-color:", ";}"], system({
  px: 5,
  py: 4
}), function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.palette.eclipse.l95;
});
var StyledHighlightedSelection = styled.span.withConfig({
  displayName: "StyledHighlightedSelection",
  componentId: "lab85s-7"
})(["font-weight:700;"]);
var StyledRegularSelection = styled.span.withConfig({
  displayName: "StyledRegularSelection",
  componentId: "lab85s-8"
})(["font-weight:normal;"]);
var StyledSuggestionsOverlay = styled.div.withConfig({
  displayName: "StyledSuggestionsOverlay",
  componentId: "lab85s-9"
})(["background-color:", ";bottom:0;left:0;opacity:0.6;position:fixed;right:0;top:0;z-index:2;"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.palette.black;
});

var highlightSearchTerm = function highlightSearchTerm(text) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var parts = text.split(new RegExp("(".concat(value, ")"), 'gi'));
  return createElement(Fragment, null, parts.map(function (part, i) {
    if (!part) return null;

    if (part.toLowerCase() !== value.toLowerCase()) {
      return createElement(StyledHighlightedSelection, {
        key: i
      }, part);
    }

    return createElement(StyledRegularSelection, {
      key: i
    }, part);
  }));
};
/**
 * @component
 */


var Search = function Search(_ref12) {
  var items = _ref12.items,
      onSubmit = _ref12.onSubmit;

  var _React$useState = useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var _React$useState3 = useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      hasActiveSuggestions = _React$useState4[0],
      setHasActiveSuggestions = _React$useState4[1];

  var searchInput = useRef$3(null);
  var isInputEmpty = !value;

  var resetValue = function resetValue() {
    return setValue('');
  };

  var handleClearButtonClick = function handleClearButtonClick(e) {
    e.preventDefault();
    resetValue();
    searchInput.current.focus();
  };

  return createElement(StyledForm, null, hasActiveSuggestions && createElement(StyledSuggestionsOverlay, {
    "data-testid": "lp-nav-search-overlay"
  }), createElement(StyledSearchWrapper, null, createElement(Downshift, {
    onStateChange: function onStateChange(e) {
      if (e.type === Downshift.stateChangeTypes.changeInput) {
        setValue(e.inputValue);
      } else if (e.type === Downshift.stateChangeTypes.keyDownEscape || e.type === Downshift.stateChangeTypes.mouseUp) {
        resetValue();
      }

      if (typeof e.isOpen !== 'undefined') {
        setHasActiveSuggestions(e.isOpen);
      }
    },
    onChange: function onChange(selection) {
      if (selection) {
        setValue(selection.value);
        onSubmit(selection.value);
      }
    },
    itemToString: function itemToString(item) {
      return item ? item.value : '';
    }
  }, function (_ref13) {
    var getInputProps = _ref13.getInputProps,
        getItemProps = _ref13.getItemProps,
        getMenuProps = _ref13.getMenuProps,
        isOpen = _ref13.isOpen,
        inputValue = _ref13.inputValue,
        highlightedIndex = _ref13.highlightedIndex;
    return createElement("div", null, createElement(StyledInput, _extends({}, getInputProps(), {
      "data-testid": "lp-nav-search-input",
      placeholder: "Search for cards\u2026",
      value: value,
      ref: searchInput
    })), createElement(StyledUnderline, {
      isActive: !isInputEmpty
    }), createElement(StyledClearButton, {
      "data-testid": "lp-nav-search-input-clear",
      hidden: isInputEmpty,
      onClick: handleClearButtonClick,
      "aria-label": "Clear"
    }, createElement(IconCross, {
      width: ICON_SIZE_PX,
      height: ICON_SIZE_PX
    })), createElement(StyledSearchButton, {
      "data-testid": "lp-nav-search-input-submit",
      disabled: isInputEmpty,
      "aria-label": "Search"
    }, createElement(IconSearch, {
      width: ICON_SIZE_PX,
      height: ICON_SIZE_PX
    })), createElement("ul", _extends({
      "data-testid": "lp-nav-search-suggestions"
    }, getMenuProps()), isOpen ? items.filter(function (item) {
      return !inputValue || item.value.toLowerCase().includes(inputValue.toLowerCase());
    }).map(function (item, index) {
      return createElement(StyledSuggestion, _extends({
        highlighted: highlightedIndex === index,
        key: item.value
      }, getItemProps({
        index: index,
        item: item
      })), highlightSearchTerm(item.value, value));
    }) : null));
  })));
};

export { CheckoutHeader, CookieBanner, Footer, Header, HeaderWrapper, LogoLink, MegaNav, Search };